import React from 'react';

function SvgEtagereMurale() {
  return (
    <svg
        className="meuble etagere_murale"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320.95 127.31"
    >
      <defs>
        <style>
          {
            ".etagere_murale_svg__etagere_murale .etagere_murale_svg__cls-2{fill:#ede8df}.etagere_murale_svg__etagere_murale .etagere_murale_svg__cls-3{fill:#fff}"
          }
        </style>
      </defs>
      <g
        id="etagere_murale_svg__Calque_2"
        className="etagere_murale_svg__etagere_murale"
        data-name="Calque 2"
      >
        <g id="etagere_murale_svg__Calque_1-2" data-name="Calque 1">
          <g className="etagere_murale_svg__cls-1" opacity={0.1}>
            <path d="M304.73 49.6v23.91h-40.24a12.68 12.68 0 0012.65-12.65v-.52a12.68 12.68 0 00-12.65-12.65H271a10 10 0 0010-10v-.41a10 10 0 00-10-10h-82.29a10 10 0 00-10 10v.41a10 10 0 0010 10H195a12.68 12.68 0 00-12.65 12.65v.52A12.68 12.68 0 00195 73.51H26.22V49.6H10v63.48h16.22v14.23h278.51v-14.23H321V49.6z" />
            <path d="M101.18 73.51a23.29 23.29 0 0014.72-5.22 23.1 23.1 0 0019-.78 17.87 17.87 0 1013.34-29.76 18.62 18.62 0 00-2.25.15 23.18 23.18 0 00-21.8-14.33 26.74 26.74 0 00-53.3 3.18h-.76a23.38 23.38 0 1015.53 40.83 23.25 23.25 0 0015.52 5.93z" />
            <rect x={182.67} y={5.38} width={80.11} height={21.82} rx={10.69} />
          </g>
          <path
            className="etagere_murale_svg__cls-2"
            d="M16.22 88.81h278.51v38.5H16.22z"
          />
          <path
            className="etagere_murale_svg__cls-3"
            d="M0 73.51h310.31v15.3H0z"
          />
          <path
            className="etagere_murale_svg__cls-3"
            d="M0 49.6h16.22v63.47H0zM294.73 49.6h16.22v63.47h-16.22zM64.74 108.29a5.77 5.77 0 11-5.74-5.76 5.76 5.76 0 015.74 5.76zM129.07 108.29a5.76 5.76 0 11-5.76-5.76 5.76 5.76 0 015.76 5.76zM193.4 108.29a5.76 5.76 0 11-5.76-5.76 5.76 5.76 0 015.76 5.76zM257.74 108.29a5.77 5.77 0 11-5.77-5.76 5.77 5.77 0 015.77 5.76z"
          />
          <path
            className="etagere_murale_svg__cls-4"
            d="M138.24 37.75a18.62 18.62 0 00-2.25.15 23.18 23.18 0 00-21.8-14.33 26.74 26.74 0 00-53.3 3.18h-.76a23.38 23.38 0 1015.53 40.83 23.32 23.32 0 0030.24.71 23.1 23.1 0 0019-.78 17.87 17.87 0 1013.34-29.76z"
            fill="#a0e9ef"
          />
          <path
            className="etagere_murale_svg__cls-3"
            d="M94.16 12.16a4.76 4.76 0 11-4.75-4.75 4.75 4.75 0 014.75 4.75zM125.15 38.59a4.76 4.76 0 11-4.75-4.76 4.75 4.75 0 014.75 4.76zM145.3 56.08a4.75 4.75 0 11-4.75-4.75 4.75 4.75 0 014.75 4.75zM110.64 57.41a4.76 4.76 0 11-4.76-4.75 4.76 4.76 0 014.76 4.75zM77.55 57.41a4.76 4.76 0 11-4.75-4.75 4.75 4.75 0 014.75 4.75zM55.07 47.9a4.76 4.76 0 11-4.76-4.75 4.76 4.76 0 014.76 4.75zM75.27 32a4.76 4.76 0 11-4.75-4.75A4.76 4.76 0 0175.27 32zM99.29 37.64a4.75 4.75 0 11-4.75-4.76 4.75 4.75 0 014.75 4.76z"
          />
          <rect
            className="etagere_murale_svg__cls-2"
            x={172.35}
            y={47.69}
            width={94.8}
            height={25.82}
            rx={12.65}
          />
          <rect
            className="etagere_murale_svg__cls-3"
            x={168.75}
            y={27.35}
            width={102.24}
            height={20.34}
            rx={9.97}
          />
          <rect
            className="etagere_murale_svg__cls-2"
            x={172.67}
            y={5.38}
            width={80.11}
            height={21.82}
            rx={10.69}
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgEtagereMurale;
